export const DISABLE_PERSONALIZED_GOOGLE_ADS = 'DISABLE_PERSONALIZED_GOOGLE_ADS';
export const INITIALIZE_PERSONALIZED_GOOGLE_ADS = 'INITIALIZE_PERSONALIZED_GOOGLE_ADS';
export const HIDE_GDPR_COOKIE_BANNER = 'HIDE_GDPR_COOKIE_BANNER';
export const INITIALIZE_GDPR_COOKIE_BANNER = 'INITIALIZE_GDPR_COOKIE_BANNER';



// WEBPACK FOOTER //
// ./app/Gdpr/actionTypes.js